export const applicantCommunicationLanguageOptions = [
  { value: "", label: "Automatisch / Fallback" },
  { value: "de", label: "Deutsch" },
  { value: "en", label: "English" },
  { value: "fr", label: "Franzoesisch" },
  { value: "tr", label: "Tuerkisch" },
  { value: "vi", label: "Vietnamesisch" },
  { value: "uk", label: "Ukrainisch" },
  { value: "bks", label: "BKS" },
  { value: "ar", label: "Arabisch" },
];

export function getApplicantCommunicationLanguageLabel(value) {
  const match = applicantCommunicationLanguageOptions.find((option) => option.value === value);
  return match?.label || "Automatisch / Fallback";
}
